import { render, staticRenderFns } from "./QueueDetail.vue?vue&type=template&id=0583105e"
import script from "./QueueDetail.vue?vue&type=script&lang=ts"
export * from "./QueueDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports